import { apiClient } from "./config/serviceConfiguration";

export default {
  getAllCatalogProducts() {
    return apiClient.get("/products/catalog");
  },
};
